const getAppSettings = state => state.settings.app;

export default getAppSettings;
